import { render } from "./InfoRegionalVariants.vue?vue&type=template&id=3deaf6d6&scoped=true"
import script from "./InfoRegionalVariants.vue?vue&type=script&lang=js"
export * from "./InfoRegionalVariants.vue?vue&type=script&lang=js"

import "./InfoRegionalVariants.vue?vue&type=style&index=0&id=3deaf6d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3deaf6d6"]])

export default __exports__